import React from "react";
import { Col, Row } from "react-bootstrap";
import ITERLogo from "../../Assets/iter_logo.png";
import RavenshawLogo from "../../Assets/ravenshaw_logo.png";

function Education() {
  return (
    <>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <Col
          xs={12}
          md={5}
          className="education-item d-flex align-items-center mb-4 mt-4"
        >
          <img src={ITERLogo} alt="ITER Logo" className="university-logo" />
          <div className="education-details ms-3">
            <h5 className="mb-2"> Institute of Technical Education and Research (ITER)
            </h5>
            <p className="mb-0">Master of Computer Applications (MCA)</p>
            <p className="mb-0">2017 - 2020</p>
          </div>
        </Col>



        <Col
          xs={12}
          md={5}
          className="education-item d-flex align-items-center mb-4 mt-4"
        >
          <img
            src={RavenshawLogo} alt="Ravenshaw Logo" className="university-logo"
          />
          <div className="education-details ms-3">
            <h5 className="mb-2">Ravenshaw University</h5>
            <p className="mb-0">BSc in Information Technology and Management (ITM) </p>
            <p className="mb-0">2020 - 2022</p>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default Education;
